module.exports = __webpack_public_path__ + "img/pay-tmp-normal-second.bd6e97c8.png";